import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { RouterProvider } from 'react-router';
import { ThemeProvider } from '@catequil/theme';

import { Snackbars } from '~/components/Snackbars';
import { persistor, store } from '~/application/store';
import { router } from '~/application/router';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ThemeProvider>
                    <Snackbars>
                        <RouterProvider router={router} />
                    </Snackbars>
                </ThemeProvider>
            </PersistGate>
        </Provider>
    </StrictMode>
);
